import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.define-property";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Thomas Barry
 */
import fireAndForget from '../network/fire-and-forget';
import postForm from '../network/post-form';
import globals from '../globals/globals';
import addUrlParam from '../add-url-param/add-url-param';
import logger from '../logger/logger';

var sendBusinessEvent = function sendBusinessEvent(eventId) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$url = _ref.url,
      url = _ref$url === void 0 ? globals().bevUrl : _ref$url,
      _ref$paramName = _ref.paramName,
      paramName = _ref$paramName === void 0 ? '_eid' : _ref$paramName,
      _ref$post = _ref.post,
      post = _ref$post === void 0 ? false : _ref$post,
      _ref$params = _ref.params,
      params = _ref$params === void 0 ? {} : _ref$params;

  if (url) {
    if (post) {
      var data = Object.assign(_defineProperty({
        F: 'J'
      }, paramName, eventId), params);
      postForm({
        url: url,
        data: data
      });
    } else {
      var configuredUrl = addUrlParam(url, paramName, eventId);
      fireAndForget({
        url: configuredUrl,
        params: {
          F: 'J'
        }
      });
    }
  } else {
    logger.warn('business-events: url is not defined');
  }
};

export default sendBusinessEvent;